import { NgModule } from '@angular/core';
import { CadastrarContratanteComponent } from './cadastrar-contratante.component';
import { RouterModule } from '@angular/router';
import { FormularioComponent } from './components/formulario/formulario.component';
import { MatFormFieldModule, MatInputModule, MatButtonModule,MatCardModule } from '@angular/material';
import { CommonModule } from '@angular/common';
import { NgxMaskModule } from 'ngx-mask'
import { FormsModule } from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSelectModule} from '@angular/material/select';
import { AngularValidateBrLibModule } from 'angular-validate-br';

@NgModule({
  declarations: [CadastrarContratanteComponent,FormularioComponent],
  imports: [
    MatFormFieldModule,
    AngularValidateBrLibModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatCardModule,
    CommonModule,
    FormsModule,
    MatIconModule,
    MatSelectModule,
    NgxMaskModule.forRoot(),
    RouterModule.forChild([
      {
        path: '', 
        pathMatch: 'full', 
        component: CadastrarContratanteComponent,
        data: {
          title: 'Cadastro de serviços'
        }
      }
    ])
  ],





  
  exports: [CadastrarContratanteComponent]
})
//export class TributosCalculoIpiModule { }
export class AppModule { }
